import { shouldRefreshToken, refreshAccessToken, clearTokens } from './authAdmin';

export async function apiFetch(url, options = {}) {
    // Proactive refresh if token expiring soon
    if (shouldRefreshToken()) {
        await refreshAccessToken();
    }

    const token = localStorage.getItem('adminToken');
    const response = await fetch(url, {
        ...options,
        headers: {
            ...options.headers,
            'Authorization': `Bearer ${token}`
        }
    });

    // Handle 401 - token expired before we could refresh
    if (response.status === 401) {
        // One more refresh attempt
        const refreshed = await refreshAccessToken();
        if (refreshed) {
            // Retry with new token
            const newToken = localStorage.getItem('adminToken');
            return fetch(url, {
                ...options,
                headers: {
                    ...options.headers,
                    'Authorization': `Bearer ${newToken}`
                }
            });
        } else {
            // Refresh failed - session truly expired.
            // PUBLIC_URL, not a bare absolute path: preview serves the app
            // under /{branch}, so '/admin/login' would strand the user at the
            // domain root, outside the app prefix (found 2026-08-21).
            clearTokens();
            window.location.href = `${process.env.PUBLIC_URL}/admin/login?expired=true`;
            throw new Error('Session expired');
        }
    }

    return response;
}
